import IIUC from "../../assets/images/IIUC.png";

export const educationData = [
	{
		id: 1,
		logo: IIUC,
		institution: "International Islamic University Chittagong",
		degree: "Bachelor of Science in Computer Science and Engineering",
		year: "2018 - Present"
	}
];
